export default function SUnansweredCall({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M3.47664 6L16.6134 19.1367L23.4425 12.3325H16.9859V7.36583H31.8857V22.2657H26.9191V15.8091L20.09 22.6134L16.6134 26.09L0 9.47664L3.47664 6Z" fill="currentColor"/>
        </svg>
    )
}